import { BuildTags, ErrorTagUtil } from '@onshape/www-inertia';
import errorReporter from '~/utils/AaaSentryIo';

declare global {
  interface Window {
    ptcDebug?: {
      payload?: Record<string, unknown>;
      dataLayerPushes?: Array<Record<string, unknown>>;
      buildTags?: {
        detailed: string;
      };
      clientQuery?: Record<
        string,
        {
          query: string;
          params?: Record<string, unknown>;
        }
      >;
      errs?: {
        push(_value: unknown): void;
      };
      _errs?: Array<unknown>;
    };
  }
}

let postedErrorCount = 0;
const MAX_POSTED_ERRORS = 3;

export default defineNuxtPlugin(() => {
  try {
    // if we don't have a window or we already have ptcDebug, we don't need to do anything
    if (!window) {
      return;
    }
    window.ptcDebug = window.ptcDebug || {};
    window.ptcDebug.buildTags = {
      detailed: BuildTags.detailed,
    };
    window.ptcDebug.payload = JSON.parse(JSON.stringify(useNuxtApp().payload));
    window.ptcDebug.clientQuery = window.ptcDebug.clientQuery || {};

    if (window.ptcDebug._errs) {
      return;
    }
    const historicClientErrors = window.ptcDebug.errs || [];
    window.ptcDebug._errs = [];
    window.ptcDebug.errs = {
      push(value: unknown) {
        if (
          errorReporter &&
          postedErrorCount < MAX_POSTED_ERRORS &&
          document.location.hostname.includes('onshape.com')
        ) {
          if (Math.random() < 0.001) {
            // quite for now
            postedErrorCount += 1;
            errorReporter.postToSentry({
              tag: ErrorTagUtil.ptcDebugClientError,
              msg: `value: ${JSON.stringify(value)}`,
            });
          }
        }
        console.error('ptcDebug.clientErr.push', value, '\n', new Error().stack);
        // at this point, we can assume that ptcDebug._errs is defined
        window.ptcDebug!._errs!.push({
          msg: value,
          trace: new Error().stack,
        });
      },
    };
    (historicClientErrors as Array<unknown>).forEach((error) => {
      if (!window) return;
      if (!window.ptcDebug || !window.ptcDebug.errs) {
        console.error('ptcDebug.errs is not defined', error);
        return;
      }
      window.ptcDebug.errs.push(error);
    });
  } catch (e) {
    console.warn('Error pushing to ptcDebug', e);
  }
});
